import {useGetAndSet} from "./useGetAndSet";
import {createSetJobStatusCountDataAction} from "../actions/dataActions";


export const useJobStatusCountData = (params, dataFresh) => {
    return useGetAndSet("jobstatuscount", params, createSetJobStatusCountDataAction, dataFresh);
}